import {
  IdeaAction,
  IdeaDetail,
  IdeaStatus,
  IdeaSummary,
  IdeaTier,
} from '@/types/service/ideaExchange';

import { baseProtectedApi } from '@/store/baseApi';

export const ideaExchangeApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    getIdeaRequests: builder.query<{ requests: IdeaSummary[]; count: number }, IdeaTier>({
      query: (tier) => ({
        url: `/v1/protected/idea-exchange/requests?tier=${tier}`,
        method: 'GET',
      }),
    }),
    getIdeaRequest: builder.query<IdeaDetail, { id: number; tier: IdeaTier }>({
      query: ({ id, tier }) => ({
        url: `/v1/protected/idea-exchange/requests/${id}?tier=${tier}`,
        method: 'GET',
      }),
    }),
    actOnIdeaRequest: builder.mutation<
      { request_id: number; status: IdeaStatus },
      { id: number; tier: IdeaTier; data: IdeaAction }
    >({
      query: ({ id, tier, data }) => ({
        url: `/v1/protected/idea-exchange/requests/${id}/actions?tier=${tier}`,
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { useGetIdeaRequestsQuery, useGetIdeaRequestQuery, useActOnIdeaRequestMutation } =
  ideaExchangeApi;
